<svelte:head>
    <title>The Phoenix Pages</title>
</svelte:head>

<script>
	import { onMount, onDestroy } from 'svelte';

    import timestr from '../lib/time';
    import { cardinal } from '../lib/geo';

    let fpscrollerL, fpscrollerR, leftScroller, rightScroller;
    
	import { db } from '../api.js';
    let api = {
        // player: {},
        // players: [],
        // shops: [],
        // places: [],
        // paths: [],
        // blank: {
        //     shop: {},
        //     place: {},
        //     path: {},
        // },
    };
    db.subscribe(val => {
        api = val;
    });
    
    onMount(async () => {        
        leftScroller = setInterval(async () => {
            if (api.shops && api.shops.length > 0) {
                fpscrollerL.children[0].style.height = '20rem';
                fpscrollerL.children[fpscrollerL.children.length-1].style.height = '0px';
                fpscrollerL.children[0].style.marginTop = '1.25rem';
                fpscrollerL.children[fpscrollerL.children.length-1].style.marginTop = '0px';
                await sleep(1);
                fpscrollerL.prepend(fpscrollerL.children[fpscrollerL.children.length-1]);
            };
        }, 1500);
        rightScroller = setInterval(async () => {
            if (api.places && api.places.length > 0) {
                fpscrollerR.children[fpscrollerR.children.length-1].style.height = '20rem';
                fpscrollerR.children[0].style.height = '0px';
                fpscrollerR.children[fpscrollerR.children.length-1].style.marginTop = '1.25rem';
                fpscrollerR.children[0].style.marginTop = '0px';
                await sleep(1);
                fpscrollerR.append(fpscrollerR.children[0]);
            };
        }, 1500);
    });

    onDestroy(async () => {
        clearInterval(leftScroller);
        clearInterval(rightScroller);
    });

    function sleep(s) {
        return new Promise(resolve => setTimeout(resolve, (s * 1000)));s
    };

    function multiply(array, iterations) {
        let newarray = [];
        for (const i of Array(iterations)) {
            newarray.push(...array);
        };
        return newarray;
    };
</script>

<div id="main" class="flex flex-col items-center justify-start w-full h-screen max-h-screen overflow-hidden">    
    <div id="fp" class="relative flex flex-row items-center justify-between w-full h-screen px-6 py-3 overflow-hidden lg:p-12 shrink-0 snap-end">
        <div class="flex flex-col items-start justify-center flex-1 h-full lg:pr-16 select-none pl-[5px] lg:pl-0">
            <div class="flex lg:flex-row flex-col items-center justify-start w-full h-[7.5rem] grow-0">
                <img src="/favicon.png" alt="Logo" class="h-full mb-1 mr-4 rounded-3xl aspect-square lg:mb-0">
                <h1 class="text-2xl font-bold text-center lg:text-5xl lg:text-left">Welcome&nbsp;to<br>The&nbsp;Phoenix&nbsp;Pages</h1>
            </div>
            <!-- <h3 class="hidden mt-5 text-2xl font-semibold lg:block">
                //<a class="mx-2" href="/api.shops">Shopping</a>
                //<a class="mx-2" href="/api.places">Places</a>
                //<a class="mx-2" href="/navigation">Directions</a>
                //<a class="mx-2" href="/">Account</a>
                //
            </h3> -->
            <!-- <hr class="invisible my-8 lg:hidden"> -->
            
            {#if api.player && api.player.PlayerDiscord}
                <div class="flex flex-row items-center justify-center w-full p-2 mt-5 font-semibold text-black border-2 rounded-lg lg:justify-start group hover:text-white after:bg-discord btn border-discord" on:click={() => {
                    window.location = '/account';
                }}>
                    <p>Good {timestr()}, {api.player.PlayerNickname || api.player.PlayerUsername}.</p>
                </div>
            {:else}
                <div class="flex flex-row items-center justify-center w-full p-2 mt-5 font-semibold text-black border-2 rounded-lg lg:justify-start group hover:text-white after:bg-discord btn border-discord" on:click={() => {
                    window.location = '/login';
                }}>
                    <p>Login with</p>
                    <div class="relative flex-1 overflow-hidden h-7">
                        <img src="/assets/icon/discord-logo-purple.svg" class="absolute top-0 left-0 ml-2 transition-opacity duration-500 ease-in-out opacity-100 h-7 group-hover:opacity-0" alt="Discord Wordmark">
                        <img src="/assets/icon/discord-logo-white.svg" class="absolute top-0 left-0 ml-2 transition-opacity duration-500 ease-in-out opacity-0 h-7 group-hover:opacity-100" alt="Discord Wordmark">
                    </div>
                </div>
            {/if}
        </div>
        <div class="flex-row items-center justify-end flex-1 hidden w-1/4 h-full gap-16 lg:flex">
            <div bind:this={fpscrollerL} class="flex flex-col items-start justify-center flex-1 h-full transform translate-y-24 rotate-12">
                {#each multiply(api.shops.sort(() => .5 - Math.random()).filter(a => a.ShopImage != ''), 6) as shop, i}
                    <div class="flex flex-col items-center justify-between w-full transition-all duration-1000 ease-in-out bg-gray-200 rounded-lg shadow-xl shrink-0" style="height: 20rem; margin-top: 1.25rem;">
                        <img src={shop.ShopImage} class="w-full rounded-lg aspect-video" alt="Cover">
                        <div class="flex flex-col items-center justify-center flex-1 w-full px-5">
                            <p class="pb-1 text-xl font-semibold text-center">{shop.ShopName}</p>
                            <p class="text-center">{shop.ShopLocation}</p>
                        </div>
                    </div>
                {/each}
            </div>
            <!-- <div bind:this={fpscrollerR} class="flex flex-col items-start justify-center flex-1 h-full transform translate-y-24 rotate-12">
                {#each api.shops.sort(() => .5 - Math.random()).filter(a => a.ShopImage != '') as shop, i}
                    <div class="flex flex-col items-center justify-between w-full transition-all duration-1000 ease-in-out bg-gray-200 rounded-lg shadow-xl shrink-0" style="height: 20rem; margin-top: 1.25rem;">
                        <img src={shop.ShopImage} class="w-full rounded-lg aspect-video" alt="Cover">
                        <div class="flex flex-col items-center justify-center flex-1 w-full px-5">
                            <p class="pb-1 text-xl font-semibold text-center">{shop.ShopName}</p>
                            <p class="text-center">{cardinal(shop.ShopCoordinates)}</p>
                        </div>
                    </div>
                {/each}
            </div> -->
            <div bind:this={fpscrollerR} class="flex flex-col items-start justify-center flex-1 h-full transform -translate-y-12 rotate-12">
                {#each multiply(api.places.sort(() => .5 - Math.random()).filter(a => a.PlaceImage != ''), 6) as place, i}
                    <div class="flex flex-col items-center justify-between w-full transition-all duration-1000 ease-in-out bg-gray-200 rounded-lg shadow-xl shrink-0" style="height: 20rem; margin-top: 1.25rem;">
                        <img src={place.PlaceImage} class="w-full rounded-lg aspect-video" alt="Cover">
                        <div class="flex flex-col items-center justify-center flex-1 w-full px-5">
                            <p class="pb-1 text-xl font-semibold text-center">{place.PlaceName}</p>
                            <p class="text-center">{cardinal(place.PlaceLocation.MainCoords)}</p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    .btn {
        position: relative;
        cursor: pointer;
        user-select: none;
        overflow: hidden;
        transition: color 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .btn::after {
        content: "";
        position: absolute;
        z-index: -1;
        padding: 0.85em 0.75em;
        display: block;
        left: -20%;
        right: -20%;
        top: 0;
        bottom: 0;
        transform: skewX(-45deg) scale(0, 1);
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn:hover::after,
    .btn:focus::after {
        transform: skewX(-45deg) scale(1, 1);
    }
</style>